// components/LSSF/FarmerApplicationsList.jsx
import React from 'react';
import BaseList from './BaseList';

const FarmerApplicationsList = () => {
  const columns = [
    { key: 'farmer_name', label: 'Farmer Name' },
    { key: 'age', label: 'Age' },
    { key: 'aadhar_number', label: 'Aadhar Number' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { key: 'land_measurement', label: 'Land Measurement' },
    { 
      key: 'land_unit', 
      label: 'Land Unit',
      render: (value) => value || 'N/A'
    },
  ];

  return (
    <BaseList
      title="Farmer Assistance Applications"
      apiEndpoint="/api/v1/mail/farmer-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-farmer-application"
      addButtonText="Add Farmer Application"
    />
  );
};

export default FarmerApplicationsList;